import { SxProps, Theme } from '@mui/material/styles';

// Match template editor surface with the same panel look as template grids.
export const templateEditorSurfaceSx: SxProps<Theme> = {
  borderRadius: 3,
  border: (theme) => `1px solid ${theme.designSystem.surface.panelBorder}`,
  background: (theme) => theme.designSystem.surface.gridPanelBackground,
  boxShadow: (theme) => theme.designSystem.surface.panelShadow,
  p: 2
};

